import { withSvgIcon } from './withSvgIcon';

export const Image = withSvgIcon(
  <>
    <path
      d="M4 18V18C4 19.1046 4.89543 20 6 20H18C19.1046 20 20 19.1046 20 18V12M4 18V6C4 4.89543 4.89543 4 6 4H18C19.1046 4 20 4.89543 20 6V12M4 18L9.03429 14.6438C9.63146 14.2457 10.3962 14.1981 11.0381 14.5191L12.9619 15.4809C13.6038 15.8019 14.3685 15.7543 14.9657 15.3562L20 12"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <circle
      cx="9"
      cy="9"
      r="2"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
  </>,
  { viewBox: '0 0 24 24' },
);
